import { lazyload } from './lazyload'

export default {
  install(app) {
    // 注册全局指令
    app.directive('lazy', lazyload)
    
    // 这里可以添加更多全局指令
  }
}
